<template>
    <b-card no-body>
        <v-table    ref="table"
                    :fields="fields"
                    :items-provider="provider"
                    pagination="server"
                    :add-callback="add"
                    :settings="false"
                    :editor="(d)=>d.Data.Data"
                    v-on:fetch-result="onFetch"
                    :buttons="buttons">
                    <template #additional-actions>
                        <div class="row w-100 justify-content-end">
                        <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                            <b-dropdown :disabled="!excelPath" text="İşlemler" right variant="primary">
                                <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Excel İndir
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        </div>
                    </template>
                <template #filters>
                    <div class="row align-items-center gy-50">
                        <div class="col-md-1 mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="donem.month">
                                <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-1 mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="donem.year">
                                <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                            </select>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="branchType">
                                <option value="O">Org. Şube</option>
                                <option value="S">SGK Şube</option>
                            </select>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="types" label="AD" v-model="type" placeholder="KYKM Türü"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'O'">
                            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'S'">
                            <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <input placeholder="Personel" class="form-control" v-model="search"/>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                        </div>
                    </div>
                </template>
            </v-table>
    </b-card>
</template>

<script>
import { BCard,BOverlay,BDropdown,BDropdownItem } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import VDatePicker from '@/components/VDatePicker.vue'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import AdvancePaymentAssign from './components/AdvancePaymentAssign.vue'
import HrNetsisApi from '@/api/hr-netsis'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        VDatePicker,
        VuePerfectScrollbar,
        BOverlay,
        AdvancePaymentAssign,
        BDropdown,
        Additional,
        BDropdownItem
    },
    data() {
        return {
            type:null,
            types:[],
            fields:[
                {thClass:'w-16',name:'Personel',key:'EmployeeFullName'},
                {thClass:'w-12',name:'Kimlik Numarası',key:'EmployeeIdentityNumber'},
                {thClass:'w-16',name:'Bordro',key:'SGKBranchInfo'},
                {thClass:'w-12',name:'KYKM Türü',key:'KYKMName'},
                {thClass:'w-12',name:'Ödeme',key:'Status'},
                {thClass:'w-16',name:'Hedef',key:'EmployeeDepartmentTitleName'},
                {thClass:'w-4',name:'Dahil',key:'Include'},
                {thClass:'w-4',name:'G/S/M',key:'GSM'},
                {thClass:'w-12',name:'Tutar',key:'AmountStr'},
                {thClass:'w-12',name:'Açıklama',key:'Description'},
            ],
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'S',
            branch:null,
            sbranch:null,
            collarStatus:null,
            search:null,
            excelPath:null,
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
        this.getTypes()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.SalaryEffect.KYKMTable({
                TIP:this.type?.TIP || null,
                SIRA_NO:this.type?.SIRA_NO || null,
                StartDate:null,
                EndDate:null,
                Filter:{
                    PaginateRequest:{
                        ...data,
                        QueryParam:this.search
                    },
                    ...this.filter
                }
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        },
        getTypes(){
            HrNetsisApi.KYKMList().then(res => {
                this.types = res.data
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        onFetch(d){
            this.excelPath=d.ExcelPath
        },
        add(){
            this.$router.push({name:'advance-payment-assign'})
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.EmployeeFullName} isimli personelin ${item.KYKMName} türündeki kykm atamasını silecektir.`).then(c => {
                if(c){
                    this.$refs.table.rowLoading(true)
                    EmployeeOperationsApi.SalaryEffect.KYKMTableDelete(item.Id).then(res => {
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                        this.$refs.table.rowLoading(false)
                        this.$result(res)
                    }).catch(err =>{
                        this.$refs.table.rowLoading(false)
                        this.$result(null,err)
                    })
                }
            })
        }
    },
    computed:{
        filter(){
            return {
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>

<style>

</style>